import api from './client';

export const getWallet = () => api.get('/wallet/');
export const getTransactions = () => api.get('/wallet/transactions/');
export const getWalletSplits = (bookingId?: string) => api.get('/wallet/splits/', { params: bookingId ? { booking_id: bookingId } : {} });
export const getAllWallets = () => api.get('/wallet/all/');
